import React, { useEffect, useState } from "react";
import { WidthPercent } from "../../../Utils/sizes";
import { Color, webTemp } from "../../../Utils/styles";
import css from "./ticket.module.css";
import { IoWomanOutline, IoManOutline } from "react-icons/io5";
import {
  addTime,
  Day,
  GenderRender,
  RenderChildPrice,
  renderMonth,
  RenderPrice,
  renderTimeShift,
  sepMoney,
  takePercent,
  ToDateJalali,
} from "../Function";
import { useShift } from "./Hooks";
import { TbDiscount2 } from "react-icons/tb";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import AuthModal from "../../View/Auth/AuthModal";
import User from "../../../Panel/User/View/Dashboard";
function ShiftTimeTable({ stracture, isEdite, isApp, multi, status, btnHtml, SelectMethod, activeMulti }) {

  const { addShift } = useShift();
  const { user } = useSelector(state => state);
  const navigate = useNavigate();
  const [showModalLogin, setShowModalLogin] = useState(false);
  const handlerDefault = () => {
    let res = "woman";
    if (stracture.data.option.needdate === "true") {
      stracture.data.times.map(time => {
        if (time.gender == "man") {
          res = "man";
        }
      });
    } else {
      Object.keys(stracture.data.times).map(key => {
        if (stracture.data.times[key]["gender"] == "man") {
          res = "man";
        }
      });
    }
    return res;
  };
  useEffect(() => {
    if (multi && multi.status) {
      multi.clearTimes();
    }
  }, [status]);
  const [type, setType] = useState(handlerDefault());
  if (stracture.data.option.needdate === "true") {
    return (
      <div className="shift-table">
        <div className={"d-flex align-items-center flex-wrap mb-4 " + (isApp && "mt-2")}>
          {[
            { key: "man", name: "آقایان" },
            { key: "woman", name: "بانوان" },
            { key: "both", name: "هردو" },
          ].map(btn => {
            return (
              <button
                onClick={() => {
                  setType(btn.key);
                }}
                key={btn.key}
                className={
                  "new-box-shadow btn shift-btn GendeBtnTimeTable " + css.btnGender + " " +
                  (type === btn.key ? "shift-btn-active" : "shift-btn-diactive ") +
                  (type === btn.key ? ` btn_${btn.key}` : "")
                } >
                {btn.name == "آقایان" && <IoManOutline size={isApp ? 18 : 22} />}
                {btn.name == "بانوان" && <IoWomanOutline size={isApp ? 18 : 22} />}
                {btn.name == "هردو" && <span><span className={css.meNIcon} ><IoWomanOutline size={isApp ? 18 : 22} /> </span><span><IoManOutline size={isApp ? 18 : 22} /></span></span>}

                {btn.name}
              </button>
            );
          })}

          {!isApp && <p className="ms-2 chooseTitle" style={{ color: "#404040" }}>
            در انتخاب شیفت، جنسیت و تاریخ را در مدنظر قرار دهید
          </p>}

        </div>
        {isApp && (
          isEdite && (
            !SelectMethod &&
            <div>
              {btnHtml}
            </div>
          ))}

        <div style={{ width: "100%" }}>

          {stracture.data.times.map((data, key) => {
            if (isApp) {
              let countGender = 0;

              data.data.map((data, index) => {
                if (data.gender === type || type === "both") {
                  countGender++;
                }
              })

              if (countGender > 0) {
                // نمایش تایم برای موبایل
                return (
                  <div style={{ borderBottom: "1px dashed #a6a6a6", paddingBottom: "12px" }}>
                    <p className="mt-3" style={{ color: "#E42A3F", fontWeight: "400", fontSize: "13px" }}>
                      {data.dayname} - {data.date}
                    </p>
                    {data.data.map((data, index) => {
                      if (data.gender === type || type === "both") {
                        return (<ShiftItem activeMulti={activeMulti} key={index} stracture={stracture} addShift={addShift} setShowModalLogin={setShowModalLogin}
                          isEdite={isEdite} data={data} user={user} multi={multi} status={status}
                          SelectMethod={SelectMethod} />
                        )
                      }
                    })}
                  </div>
                );
              }
            } else {
              if (data.gender === type || type === "both") {
                return (
                  <div key={key} className={'d-flex align-items-center ' + css.ticketListItem}>
                    <Date data={data} />

                    {data?.title &&
                      <>
                        <Title data={data} isPool={true} />
                        <span className={css.lineBreak1}></span>
                      </>
                    }

                    <Time data={data} isPool={true} />
                    <span className={css.lineBreak1}></span>
                    <div className={css.GenderCapocityBox}>
                      <Gender data={data} />
                      {/* <Capocity data={data} edit={stracture.edit} isPool={true} /> */}
                    </div>
                    <span className={css.lineBreak}></span>

                    <Price
                      isPool={true}
                      data={data}
                      timeOption={stracture.data.option}
                      item={stracture.item}
                      edit={stracture.edit}
                      method={stracture.method}
                      btnText={isEdite ? "ویرایش" : data.capacity > 0 ? "خرید بلیت" : "اتمام ظرفیت"}
                      setShowModalLogin={setShowModalLogin}
                      isEdite={isEdite}
                    />
                  </div>
                );
              }
            }

          })}

        </div>
        <AuthModal show={showModalLogin} setShow={setShowModalLogin} />
      </div>
    );
  }

  return (
    <div className="shift-table" style={{ marginTop: "20px" }}>
      <div className="d-flex align-items-center flex-wrap mb-4">
        {[
          { key: "man", name: "آقایان" },
          { key: "woman", name: "بانوان" },
          { key: "both", name: "هردو" },
        ].map(btn => {
          return (
            <button
              onClick={() => {
                setType(btn.key);
              }}
              className={
                "new-box-shadow btn shift-btn GendeBtnTimeTable " + css.btnGender + " " +
                (type === btn.key ? "shift-btn-active" : "shift-btn-diactive ") +
                (type === btn.key ? ` btn_${btn.key}` : "")
              }
              key={btn.key}
            >

              {btn.name == "آقایان" && <IoManOutline size={isApp ? 18 : 22} />}
              {btn.name == "بانوان" && <IoWomanOutline size={isApp ? 18 : 22} />}
              {btn.name == "هردو" && <span><span className={css.meNIcon} ><IoWomanOutline size={isApp ? 18 : 22} /> </span><span><IoManOutline size={isApp ? 18 : 22} /></span></span>}

              {btn.name}
            </button>
          );
        })}

        {!isApp && <p className="chooseTitle" style={{ color: "#404040", fontWeight: "400" }}>
          در انتخاب شیفت، جنسیت و تاریخ را در مدنظر قرار دهید
        </p>}
      </div>
      {isApp && (
        isEdite && (
          !SelectMethod &&
          <div>
            {btnHtml}
          </div>
        ))}
      <div style={{ width: "100%" }}>
        <div>
          <div style={{ flex: 1 }}>
            {Object.keys(stracture.data.times).map(key => {
              const data = stracture.data.times[key];

              if (data.gender === type || type === "both") {
                if (isApp) {
                  return (
                    <ShiftItem isGym={true} activeMulti={activeMulti} keyId={key} stracture={stracture} addShift={addShift} setShowModalLogin={setShowModalLogin}
                      isEdite={isEdite} data={{ ...data, id: key }} user={user} multi={multi} status={status} showTitle={true} SelectMethod={SelectMethod} />
                  )
                }
                else {
                  return (
                    <div key={key} className={'d-flex align-items-center ' + css.ticketListItem}>
                      <Title data={data} />
                      <Time data={data} />
                      <span className={css.lineBreak1}></span>
                      <div className={css.GenderCapocityBox}>
                        <Gender data={data} />
                        <Capocity data={data} edit={stracture.edit} />
                      </div>
                      <span className={css.lineBreak1}></span>
                      {data?.session &&
                        <div className={css.GenderSessionBox}>
                          تعداد جلسات : {data?.session}
                        </div>
                      }
                      <span className={css.lineBreak}></span>
                      <Price
                        data={{ ...data, id: key }}
                        timeOption={stracture.data.option}
                        item={stracture.item}
                        edit={stracture.edit}
                        classPriceBox={css.priceBoxGym}
                        btnText={isEdite ? "ویرایش" : "رزرو"}
                        setShowModalLogin={setShowModalLogin}
                        isEdite={isEdite}
                      />
                    </div>
                  );
                }
              }
            })}
          </div>
        </div>
      </div>
      <AuthModal show={showModalLogin} setShow={setShowModalLogin} />
    </div>
  );
}

export default ShiftTimeTable;

const Date = ({ data }) => {
  return (
    <div className={' ' + css.dateBox}>
      <span>{Day(data.day)}</span>
      <span>
        {ToDateJalali(data.date).split("/")[2]}
        <span className="mx-1"></span>
        {renderMonth(ToDateJalali(data.date).split("/")[1])}
      </span>
    </div>
  );
};

const Time = ({ data, isPool }) => {
  return (
    <div className={`${css.dataBox} ${isPool && css.mr0}`}>
      {/* <svg className={`bi bi-clock-history ${css.timeicom}`} xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16"><path d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022l-.074.997zm2.004.45a7.003 7.003 0 0 0-.985-.299l.219-.976c.383.086.76.2 1.126.342l-.36.933zm1.37.71a7.01 7.01 0 0 0-.439-.27l.493-.87a8.025 8.025 0 0 1 .979.654l-.615.789a6.996 6.996 0 0 0-.418-.302zm1.834 1.79a6.99 6.99 0 0 0-.653-.796l.724-.69c.27.285.52.59.747.91l-.818.576zm.744 1.352a7.08 7.08 0 0 0-.214-.468l.893-.45a7.976 7.976 0 0 1 .45 1.088l-.95.313a7.023 7.023 0 0 0-.179-.483zm.53 2.507a6.991 6.991 0 0 0-.1-1.025l.985-.17c.067.386.106.778.116 1.17l-1 .025zm-.131 1.538c.033-.17.06-.339.081-.51l.993.123a7.957 7.957 0 0 1-.23 1.155l-.964-.267c.046-.165.086-.332.12-.501zm-.952 2.379c.184-.29.346-.594.486-.908l.914.405c-.16.36-.345.706-.555 1.038l-.845-.535zm-.964 1.205c.122-.122.239-.248.35-.378l.758.653a8.073 8.073 0 0 1-.401.432l-.707-.707z" /><path d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0v1z" /><path d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5z" /></svg> */}
      {renderTimeShift(data.start)}
      <span className={css.toTimeBox}>
        الی
      </span>
      {renderTimeShift(data.end)}
    </div>
  );
};

const Title = ({ data, isPool }) => {
  return (
    <div className={`${isPool ? css.pollTitle : css.dateBoxGym}`}>
      {!isPool && <img
        src={window.origin + "/WebSide/assets/images/damble.png"}
        alt="همه ملاقات"
        className={css.dambelImgFilter}
      />}
      <p className={css.titleNameGym}>
        {data.title}
      </p>
    </div>
  );
};
const Gender = ({ data }) => {
  return (
    <div className={css.genderBox}>
      {/* {data.gender == "man"
        ? <IoManOutline size={27} />
        : <IoWomanOutline size={27} />
      } */}
      {data.gender == "man"
        ?
        <span>
          ویژه  {GenderRender(data.gender)}
        </span>
        :
        <span>
          ویژه  {GenderRender(data.gender)}
        </span>
      }

    </div>
  );
};

const Capocity = ({ data, edit }) => {
  return (
    <div className={css.capacityBox}>
      {edit
        ?
        <span>
          تعداد رزرو :
          <span className={css.capacityCount}>
            {data.reservecount}  نفر
          </span>
        </span>

        :
        <span>
          ظرفیت :
          <span className={css.capacityCount}>
            {data.capacity}  نفر
          </span>
        </span>
      }

    </div>
  );
};

const Price = ({ isPool, data, item, edit = {}, method, classPriceBox, btnText, timeOption, setShowModalLogin, isEdite }) => {
  const { addShift } = useShift();
  const { user } = useSelector(state => state);
  return (
    <>
      <div className={css.lastBox + " " + classPriceBox}>
        <div className={css.mainPriceBox}>
          <p className={css.titleprice}>
            بزرگسال
          </p>

          <div className={css.priceBox}>

            {data?.second_price
              ? <div className={css.offPriceBox}>
                <del>
                  <span className={css.offAmount}>
                    {RenderPrice({ price: data.boxofficeprice })}
                  </span>
                </del>
                <span className={css.offPercentBox}>
                  {takePercent({ price: data.boxofficeprice, second_price: data.second_price })} %
                </span>
              </div>
              : +data.boxofficeprice > +data.price &&
              <div className={css.offPriceBox}>
                <del>
                  <span className={css.offAmount}>
                    {RenderPrice({ price: data.boxofficeprice })}
                  </span>
                </del>
                <span className={css.offPercentBox}>
                  {takePercent({ price: data.boxofficeprice, second_price: data.price })} %
                </span>
              </div>
            }
            <ins>
              <span className="amount">
                {RenderPrice(data)}
              </span>
            </ins>
          </div>
        </div>
      </div>
      {data.childprice &&
        <div className={css.lastBox + " " + classPriceBox}>

          <div className={css.mainPriceBox}>
            <p className={css.titleprice}>
              خردسال
            </p>

            <div className={css.priceBox}>

              {data?.second_child_price
                ? <div className={css.offPriceBox}>
                  <del>
                    <span className={css.offAmount}>
                      {RenderPrice({ price: data.boxofficechildprice })}
                    </span>
                  </del>
                  <span className={css.offPercentBox}>
                    {takePercent({ price: data.boxofficechildprice, second_price: data.second_child_price })} %
                  </span>
                </div>
                : +data.boxofficechildprice > +data.childprice &&
                <div className={css.offPriceBox}>
                  <del>
                    <span className={css.offAmount}>
                      {RenderPrice({ price: data.boxofficechildprice })}
                    </span>
                  </del>
                  <span className={css.offPercentBox}>
                    {takePercent({ price: data.boxofficechildprice, second_price: data.childprice })} %
                  </span>
                </div>
              }


              <ins>
                <span className="amount">
                  {RenderChildPrice(data)}
                </span>
              </ins>
            </div>
          </div>
        </div>
      }
      <div className={`${css.byBox} ${isPool && css.byBoxPool}`}>
        {/* <span className={css.lineTicket}></span> */}
        <button className={'btn btn-outline-danger ' + css.btnBuyTicket + (isPool ? " buyBtnPool" : " buyBtnGym")}
          onClick={() => {
            if (user) {
              if (edit && edit.method) {
                edit.method(data);
              } else {
                addShift({
                  time: data,
                  item,
                  expiryTime: addTime(100),
                  count: 1,
                  childcount: 0,
                  timeOption
                });
              }
            } else {
              toast.error("کاربر محترم لطفا ابتدا ثبت نام کنید");
              setTimeout(() => {
                setShowModalLogin(true)
              }, 1000);
            }
          }}

          style={{ opacity: !isEdite && data.capacity == 0 && "0.7", pointerEvents: !isEdite && data.capacity == 0 && "none" }}
        >
          {btnText}
        </button>
      </div>

    </>
  );
};

const ShiftItem = ({ isGym, activeMulti, stracture, addShift, setShowModalLogin, isEdite, data, user, multi, status, showTitle, keyId, SelectMethod }) => {
  const dispatch = useDispatch();

  const [selected, setSelected] = useState(false)

  useEffect(() => {
    if (!activeMulti) {
      setSelected(false)
    }
  }, [activeMulti])


  return (
    <div className="d-flex w-100 border rounded mt-2">
      <div className="flex-fill p-2" style={{ fontSize: "12px", fontWeight: "400" }}>
        <p className="mb-2 d-flex align-items-center">
          {data.gender == "man"
            ? <IoManOutline size={22} style={{ marginLeft: "4px" }} />
            : <IoWomanOutline size={22} style={{ marginLeft: "4px" }} />
          }

          {showTitle &&
            <span style={{ marginLeft: "auto" }}>
              {data.title}
            </span>
          }

          {data.start} الی  {data.end}
        </p>
        {!isEdite &&
          <>
            <p>
              بزرگسال :
              {+data.boxofficeprice > +data.price &&
                <span className="text-danger ml-2"
                  style={{ fontSize: "10px", textDecoration: "line-through" }}>
                  {sepMoney(data.boxofficeprice)} تومان
                </span>
              }
              <span className="text-success">{sepMoney(data?.second_price || data.price)} تومان</span>
            </p>
            {data.childprice &&
              <p>
                خردسال :
                {+data.boxofficechildprice > +data.childprice &&
                  <span className="text-danger ml-2"
                    style={{ fontSize: "10px", textDecoration: "line-through" }}>
                    {sepMoney(data.boxofficechildprice)} تومان
                  </span>
                }
                <span className="text-success">{sepMoney(data?.second_child_price || data.childprice)} تومان</span>
              </p>
            }

            {isGym && (
              <div className="d-flex justify-content-between mt-2">
                {data?.session &&
                  <p>
                    تعداد جلسات : {data?.session}
                  </p>
                }
                {data?.capacity &&
                  <p>
                    ظرفیت : {data?.capacity}
                  </p>
                }
              </div>
            )}

          </>
        }

      </div>
      <div className={"text-center text-white d-flex align-items-center justify-content-center "
        + (!isEdite && (data.capacity == 0 && "completionCapacity"))}
        style={{ width: "100px", background: selected ? "#28a745" : "#E42A3F", borderRadius: "4px 0px 0px 4px", fontSize: "14px" }}
        onClick={() => {
          if (user) {
            if (SelectMethod) {
              dispatch({
                type: "SET",
                payload: { PAData: { status: true, id: keyId } },
              });
            }
            else if (stracture.edit && stracture.edit.method) {
              if (multi && multi.status && status) {
                multi.toggleSelect(data.id, data.day, data.daykey, data);
                setSelected(!selected)
              }
              else {
                if (keyId) {
                  stracture.edit.method({ ...data, id: keyId });
                }
                else {
                  stracture.edit.method(data);
                }
              }
            } else {
              addShift({
                time: data,
                item: stracture.item,
                expiryTime: addTime(100),
                count: 1,
                childcount: 0,
                timeOption: stracture.data.option
              });
            }
          } else {
            toast.error("کاربر محترم لطفا ابتدا ثبت نام کنید");
            setTimeout(() => {
              setShowModalLogin(true)
            }, 1000);
          }
        }}>
        {isEdite ? "ویرایش" : data.capacity > 0 ? "خرید بلیت" : "اتمام ظرفیت"}
      </div>
    </div>
  )
}
